import { ApiError, NetworkError } from "../api/client.js";

/**
 * 把错误翻译成一句人话。
 *
 * 后端的 `error` code 是给程序看的，这里是给用户看的唯一一处映射。刻意不把
 * code 直接显示出来 —— `entry_conflict` 对写日记的人没有任何意义。
 */
export function errorMessage(error: unknown): string {
  if (error instanceof NetworkError) {
    return "网络不太好，稍后再试一次。";
  }
  if (error instanceof ApiError) {
    switch (error.code) {
      case "unauthenticated":
      case "invalid_credentials":
        return "登录已过期，请重新登录。";
      case "not_found":
        return "没有找到这篇日记，可能它已被删除或改为私密。";
      case "not_paired":
        return "还没有配对，暂时写不了日记。";
      case "entry_conflict":
        return "这篇在别处被改过，刷新后再试。";
      case "username_taken":
        return "这个名字已经有人用了，换一个。";
      case "invalid_current_password":
        return "当前密码不对。";
      case "code_expired":
        return "配对码已过期，可以重新生成一个。";
      case "rate_limited":
      case "locked":
        return error.retryAfterSeconds !== undefined
          ? `操作太频繁，请 ${error.retryAfterSeconds} 秒后再试。`
          : "操作太频繁，请稍后再试。";
      case "invalid_code":
        return "配对码不对，检查一下是否输错了。";
      case "already_paired":
        return "你们已经配对过了。";
      case "already_initialized":
        return "这个日记本已经初始化过了。";
      case "attachments_unavailable":
        return "图片服务暂时不可用。";
      case "internal":
        return "服务器出了点问题，稍后再试。";
      default:
        return "出了点问题，稍后再试。";
    }
  }
  return "出了点问题，稍后再试。";
}
